import { render } from "./PreDatos.vue?vue&type=template&id=e253e82a&scoped=true&ts=true"
import script from "./PreDatos.vue?vue&type=script&lang=ts"
export * from "./PreDatos.vue?vue&type=script&lang=ts"

import "./PreDatos.vue?vue&type=style&index=0&id=e253e82a&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e253e82a"]])

export default __exports__